module.exports = __webpack_public_path__ + "static/media/BrightBee_SkandiaMäklarna-Logo.4f8e98f6.png";